// Global Instructions Rule Applied!

import React from 'react'
import type { DistributionListFilterOption } from '../../../state_manager/data_models/distribution_list_grid_model.ts'

// Two-line render for the contact <Select> dropdown options: the name on top,
// the email beneath in smaller secondary text. Disambiguates duplicate-named
// contacts (architect ruling 2026-05-18, §2.15f — the "Matt Clifford" case:
// two non-trashed records, only one resolvable, identical labels). Shared by
// the Phase 5 Send Communication screen AND the Phase 4 Definition full-form
// so the house pattern stays consistent across the module.
export const renderContactOption = (d: DistributionListFilterOption): React.ReactNode => (
  <div style={{ lineHeight: 1.25 }}>
    <div>{d.label}</div>
    {d.email ? <div style={{ fontSize: 12, color: '#8c8c8c' }}>{d.email}</div> : null}
  </div>
)

// Client-side search matches the name OR the email (the disambiguation goal —
// an operator can now type the email to pick the right duplicate).
export const contactOptionFilter = (
  input: string,
  option?: DistributionListFilterOption
): boolean => {
  const q = (input || '').trim().toLowerCase()
  if (!q) return true
  return `${option?.label ?? ''} ${option?.email ?? ''}`.toLowerCase().includes(q)
}
